import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ToastService } from '../../../../services/toast.service';
import { DialogService } from '../../../../services/dialog.service';
import { AbdominalService } from '../../../../services/abdominal.service';

// ✅ USA O MODEL REAL
import { Abdominal } from '../../../../models/abdominal';

@Component({
  selector: 'app-admin-abdominal',
  templateUrl: './admin-abdominal.component.html',
  styleUrls: ['./admin-abdominal.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdminAbdominalComponent implements OnInit {

  form!: FormGroup;
  editando = false;

  dataSource!: MatTableDataSource<Abdominal>;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  displayedColumns: string[] = [
    'id',
    'nome',
    'actions',
  ];

  constructor(
    private fb: FormBuilder,
    private service: AbdominalService,
    private toastService: ToastService,
    private dialogService: DialogService,
  ) {}

  ngOnInit(): void {
    this.buildForm();
    this.load();
  }

  buildForm() {
    this.form = this.fb.group({
      id: [0],
      nome: [''],
      video: [''], // ✔ mantém string (form sempre string)
      comoExecutar: ['']
    });
  }

  load() {
    this.service.getAll().subscribe(res => {

      // 🔥 GARANTE COMPATIBILIDADE (normaliza undefined)
      const data = res.map(x => ({
        ...x,
        video: x.video ?? ''
      }));

      this.dataSource = new MatTableDataSource<Abdominal>(data);

      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  editar(item: Abdominal) {
    this.editando = true;

    this.form.patchValue({
      ...item,
      video: item.video ?? ''
    });
  }

  novo() {
    this.editando = false;

    this.form.reset({
      id: 0,
      nome: '',
      video: '',
      comoExecutar: ''
    });
  }

  salvar() {
    const data = this.form.value as Abdominal;

    if (this.editando) {
      this.service.update(data).subscribe({
        next: () => {
          this.toastService.show('Editado com sucesso', { type: 'success' });
          this.load();
        },
        error: () => {
          this.toastService.show('Erro ao editar!', { type: 'danger' });
        }
      });

    } else {

      this.service.create(data).subscribe({
        next: () => {
          this.toastService.show('Criado com sucesso', { type: 'success' });
          this.novo();
          this.load();
        },
        error: () => {
          this.toastService.show('Erro ao criar!', { type: 'danger' });
        }
      });

    }
  }

  async remover(id: number) {
    const confirmado = await this.dialogService.confirm('Deseja realmente excluir?', 'Tem certeza?');

    if (confirmado) {
      this.service.delete(id).subscribe({
        next: () => {
          this.toastService.show('Excluído com sucesso', { type: 'success' });
          this.load();
        },
        error: () => {
          this.toastService.show('Erro ao excluir!', { type: 'danger' });
        }
      });
    }
  }
}